import React, { useMemo } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { graphql, useStaticQuery } from "gatsby"
import { get } from "lodash"
import styled from "styled-components"

const ImageWrapper = styled.div`
  overflow: hidden;
  height: ${props => props.height || "auto"};
  width: ${props => props.width || "auto"};
  filter: ${props => props.filter || "none"};
  > .gatsby-image-wrapper {
    height: 100% !important;
  }
`

export const StandardImage = ({ image, ...restProps }) => {
  const xOffset = get(image, ["hotspot", "x"], 1)
  const yOffset = get(image, ["hotspot", "y"], 1)

  return (
    <ImageWrapper
      height={restProps.height}
      width={restProps.width}
      filter={restProps.filter}
    >
      <GatsbyImage
        layout="constrained"
        image={{
          ...get(image, ["asset", "fluid"], ""),
          // Make sure that srcSet is not null
          srcSet: get(image, ["asset", "fluid", "srcSet"], "") || "",
          sizes: get(image, ["asset", "fluid", "sizes"], "") || "",
        }}
        imgStyle={{
          // ...restProps,
          height: restProps.height,
          width: "100%",
          objectPosition: `${xOffset * 100}% ${yOffset * 100}%`,
        }}
        loading="lazy"
      />
    </ImageWrapper>
  )
}

const Image = ({ id, ...props }) => {
  const data = useStaticQuery(graphql`
    query {
      allSanityImageAsset {
        nodes {
          _id
          gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 650)
        }
      }
    }
  `)

  const match = useMemo(
    () => data.allSanityImageAsset.nodes.find(({ _id }) => id === _id),
    [data, id]
  )

  return (
    match &&
    match.gatsbyImageData && (
      <ImageWrapper
        height={props.height}
        width={props.width}
        filter={props.filter}
      >
        <GatsbyImage
          layout="constrained"
          image={match.gatsbyImageData}
          alt={props.imageAlt || "image"}
          loading="lazy"
          fadeIn={true}
        />
      </ImageWrapper>
    )
  )
}

export default Image
